import type { RelationMap } from '../types.js';

/**
 * 输入映射数据
 * 只作为输入关系链判断，包含一些通用关系
 */
export const inputData: RelationMap = {
  'xb': ['兄弟', '亲兄弟', '同胞兄弟'],
  'xb,w': ['兄弟媳妇', '兄弟妇'],
  'xs': ['姐妹', '亲姐妹', '同胞姐妹'],
  'xs,h': ['姐妹夫', '姊妹婿'],
  'f,xb': ['伯叔父'],
  'f,xb,w': ['伯叔母'],
  'f,f,xb': ['从祖祖父', '从祖父'],
  'f,f,xb,w': ['从祖祖母', '从祖母'],
  'm,f,xb': ['外从祖祖父'],
  'm,f,xb,w': ['外从祖祖母'],
  'h,xb': ['伯叔'],
  'h,xb,w': ['妯娌', '娣姒', '娣姒姊妹', '婶子'],
};

export default inputData;
